module.exports = __webpack_public_path__ + "img/ic_variety@2x.339f12fa.png";